'use client';

import React from 'react';

import { useParams } from 'next/navigation';

import { useBlogTracking } from '@/modules/blog/hooks/useBlogTracking';

export function ArticleLink({
  children,
  href,
  onClick,
  ...rest
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  const { sendBlogInteractionActionEvent } = useBlogTracking();
  const { slug } = useParams<{ slug: string }>();

  function handleClick() {
    sendBlogInteractionActionEvent({
      interactionType: 'ArticleLinkClick',
      articleSlug: slug,
      itemName: href,
    });
  }

  return (
    <a href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
